const initAppState = ['$rootScope', ($rootScope) => {

    // making explicit what properties the state object holds
    $rootScope.State = {
        page: null,
        state: null,
        ftu: null,
        loading: null,
        finishedLoadingAnimation: null,
        isThirdPartyLogin: null,
        deviceId: null,
        noscroll: null,
        skipFtu: null,
        hideDashboard: null,
        origin: null,
        hasModal: null,
        previousUrl: null,
        npsScore: null,
        theme: null,
        isFromSpotlightWebApp: null,
        deploySteps: [],
        partner: CWCONFIG.partnerConfig || null,
        unsubscribeAnimation: null,
    };

    const partnerId = CWCONFIG.partnerConfig.themeId;
    window.document.body.className += ` ${partnerId}`;

}];


export default initAppState;



// WEBPACK FOOTER //
// ./scripts/app/initAppState.js